<template>
	<div>
		<a-spin :spinning="loading">
			<div class="ft20 cl-main ftw600">{{artificer}}管理</div>
			
			<div class="mt20 ">
				<a-radio-group v-model="search.mendian_id" button-style="solid" @change="changeMendian">
					<a-radio-button :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">
						{{item.name}}
					</a-radio-button>
				</a-radio-group>
			</div>

			<div class="mt20">
				<div class="form-search-box ">
					<a-form layout="inline">
						<!-- <a-form-item label="所属门店">
							<div>
								<a-select style="width: 120px" placeholder="请选择" v-model="search.mendian_id">
									<a-select-option :value="0">请选择</a-select-option>
									<a-select-option :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">{{item.name}}</a-select-option>
								</a-select>
							</div>
						</a-form-item> -->
						<a-form-item label="姓名">
							<a-input v-model="search.name" :placeholder="'请输入姓名'"></a-input>
						</a-form-item>
			
						<a-form-item label="手机号">
							<a-input v-model="search.mobile" placeholder="请输入手机号"></a-input>
						</a-form-item>
						<a-form-item>
							<a-button @click="searchAct" type="primary">查询</a-button>
							<a-button @click="cancelAct" class="ml10">取消</a-button>
						</a-form-item>
					</a-form>
				</div>
			</div>
			
			<div class="mt20">
				<div class="pd30 bg-w " style="min-height: 800px;">
					<div>
						<a-button type="primary" icon="plus" @click="addTechnicianAct()">添加{{artificer}}</a-button>
					</div>
			
					<div class="mt20 ">
						<a-radio-group v-model="search.status" button-style="solid" @change="changeStatus">
							<a-radio-button :value="1">
								在职
							</a-radio-button>
							<a-radio-button :value="-1">
								离职
							</a-radio-button>
						</a-radio-group>
					</div>
			
					<div class=" mt20">
						<div class="flex wrap" v-if="datas.length>0">
							<div class="appointment-technician-item" v-for="(item,index) in datas">
								<div class="appointment-technician-item-header">
									<div class="flex space">
										<div class="flex alcenter">
											<img :src="item.face" class="appointment-technician-item-face"/>
											<div class="ml16">
												<div class="flex alcenter">
													<div class="ft16 ftw600 cl-main text-over">{{item.name}}</div>
													<div class="appointment-technician-item-tag-status-on text-over ml4" v-if="item.status==1">{{item.status_means}}</div>
													<div class="appointment-technician-item-tag-status-off text-over ml4" v-if="item.status==-1">{{item.status_means}}</div>
													<div class="appointment-technician-item-tag-year text-over ml4">{{item.working_collar}}年经验</div>
												</div>
												<div class="mt16 flex alcenter">
													<i class="iconfont iconcall_gray cl-notice ft12"/>
													<div class="ft12 ftw400 cl-info ml4 text-over">{{item.mobile}}</div>
												</div>
												
												<div class="mt16 flex alcenter">
													<i class="iconfont icongongpai cl-notice ft14"/>
													<div class="ft12 ftw400 cl-info ml4 text-over">{{item.job_number}}</div>
												</div>

												<div class="mt16 flex alcenter">
													等级：
													<div class="ft12 ftw400 cl-info ml4 text-over" v-if="item.level == 1">资深治疗师</div>
													<div class="ft12 ftw400 cl-info ml4 text-over" v-if="item.level == 2">总监治疗师</div>
													<div class="ft12 ftw400 cl-info ml4 text-over" v-if="item.level == 3">专家治疗师</div>
												</div>

												<div class="mt16 flex alcenter">
													门店：
													<div class="ft12 ftw400 cl-info ml4 text-over">{{item.mendian.name ? item.mendian.name : '暂无'}}</div>
												</div>

												<div class="mt16 flex alcenter">
													排序：
													<div class="ft12 ftw400 cl-info ml4 text-over">{{item.sort}}</div>
												</div>
											</div>
										</div>
										
										<div>
											<a-dropdown placement="bottomRight">
												<span class="more-act">
													<i class="iconfont iconmore_gray"></i>
												</span>
												<a-menu slot="overlay" >
													<a-menu-item>
														<a class="menu-act" href="javascript:;" @click="getDetailAct(index)">
															<i class="iconfont ft14 iconsee"></i>
															<span class="ml10">查看详情</span>
														</a>
													</a-menu-item>
													  <a-menu-item v-if="item.status==1">
														<a class="menu-act" href="javascript:;" @click="editTechnicianAct(index)">
															<i class="iconfont ft14 iconedit"></i>
															<span class="ml10">编辑{{artificer}}</span>
														</a>
													  </a-menu-item>
													  <a-menu-item  v-if="item.status==1" @click="quitAct(index)">
														<a class="menu-act" href="javascript:;">
															<i class="iconfont ft14 iconleave"></i>
															<span class="ml10">设为离职</span>
														</a>
													  </a-menu-item>
													  <a-menu-item  v-if="item.status==-1" @click="delAct(index)">
															<a class="menu-act" href="javascript:;" >
																<i class="iconfont ft14 icondelete"></i>
																<span class="ml10">删除帐号</span>
															</a>
													  </a-menu-item>
												</a-menu>
											  </a-dropdown>
										</div>
									</div>
								</div>
								<div class="appointment-technician-item-content">
									<div class="flex">
										<div class="col2 text-center">
											<div class="ft14 ftw400 cl-black">{{item.projects_count}}个</div>
											<div class="ft12 ftw400 cl-info mt8 text-over">服务项目</div>
										</div>
										<div class="col2 text-center">
											<div class="ft14 ftw400 cl-black">{{item.engaged_num}}次</div>
											<div class="ft12 ftw400 cl-info mt8 text-over">被约人次</div>
										</div>
									</div>
								</div>
								<div class="appointment-technician-item-footer">
									<div class="mt16">
										<div class="ft12 ftw400 cl-info text-over">技能标签：</div>
										<div class="ft12 ftw400 cl-black mt8 text-over">{{item.tags_string ? item.tags_string : '暂无'}}</div>
									</div>
								</div>
							</div>
						</div>
						
						<div class="flex center" v-else>
							<a-empty/>
						</div>
						
						<div class="flex center mt20">
							<a-pagination @change="pageChange" :total="pagination.total" v-model="pagination.current" :pageSize="pagination.pageSize" show-less-items />
						</div>
						
						<div v-if="editTechnicianVisible">
							<edit-technician :technician_id="technician_id" :visible="editTechnicianVisible" @cancel="cancelEditTechnician" @ok="okEditTechnician"></edit-technician>
						</div>
					</div>
				</div>
			
			</div>
		</a-spin>
	</div>
</template>

<script>
	import {
		listMixin
	} from '../../common/mixin/list.js';
	import EditTechnician from './components/technician/modal/EditTechnician.vue';
	export default {
		mixins: [listMixin],
		components:{
			EditTechnician,
		},
		data() {
			return {
				loading: false,
				editTechnicianVisible:false,
				pagination: {
					current: 1,
					pageSize: 8, //每页中显示10条数据
					total: 0,
				},
				technician_id:0,
				search: {
					name: '',
					mobile: '',
					status: 1,
					mendian_id:0
				},
				datas: [],
				mendians: []
			}
		},
		created(){
			this.getMendians();
		},
		methods: {
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getLists() {
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getTechnicianList',{
					limit:this.pagination.pageSize,
					page:this.pagination.current,
					name:this.search.name,
					mobile:this.search.mobile,
					status:this.search.status,
					mendian_id:this.search.mendian_id,
				}).then(res=>{
					this.pagination.total=res.total;
					this.datas=res.list;
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
				})
			},
			
			quitAct(index){
				this.$confirm({
					title:'确认这个技师离职吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/quitTechnician',{
								technician_id:this.datas[index].technician_id,
							}).then(res=>{
								this.$message.success('离职成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			delAct(index){
				this.$confirm({
					title:'确认删除这个技师吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/delTechnician',{
								technician_id:this.datas[index].technician_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			//编辑技师
			addTechnicianAct(){
				this.technician_id=0;
				this.editTechnicianVisible=true;
			},
			editTechnicianAct(index){
				this.technician_id=this.datas[index].technician_id;
				this.editTechnicianVisible=true;
			},
			cancelEditTechnician(){
				this.editTechnicianVisible=false;
			},
			okEditTechnician(){
				this.editTechnicianVisible=false;
				this.getLists();
			},
			
			//获取技师详情
			getDetailAct(index){
				this.$router.push('/appointment/technicianDetail?id='+this.datas[index].technician_id)
			},
			
			changeStatus() {
				this.pagination.current = 1;
				this.getLists();
			},
			changeMendian() {
				this.pagination.current = 1;
				this.getLists();
			},
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
		}
	}
</script>

<style>
	
	@media screen and (min-width:1901px){
		.appointment-technician-item{
			width: 24%;
			margin-right: 1%;
			margin-bottom: 1%;
			background: #FFFFFF;
			border: 1px solid #EBEDF5;
			padding: 20px;
			line-height: 1;
		}
	}
	
	@media screen and (min-width: 1551px) and (max-width: 1900px) {
		.appointment-technician-item{
			width: 32%;
			margin-right: 1%;
			margin-bottom: 1%;
			background: #FFFFFF;
			border: 1px solid #EBEDF5;
			padding: 20px;
			line-height: 1;
		}
	}
	
	@media screen and (min-width: 1161px) and (max-width: 1550px) {
		.appointment-technician-item{
			width: 49%;
			margin-right: 1%;
			margin-bottom: 1%;
			background: #FFFFFF;
			border: 1px solid #EBEDF5;
			padding: 20px;
			line-height: 1;
		}
	}
	
	@media screen and (max-width: 1160px) {
		.appointment-technician-item{
			width: 99%;
			margin-right: 1%;
			margin-bottom: 1%;
			background: #FFFFFF;
			border: 1px solid #EBEDF5;
			padding: 20px;
			line-height: 1;
		}
	}
	
	
	.appointment-technician-item-header{
		padding-bottom: 16px;
		border-bottom: 1px solid #EBEDF5;
	}
	
	.appointment-technician-item-face{
		width: 100px;
		height: 100px;
	}
	
	.appointment-technician-item-tag-status-on{
		border-radius: 2px;
		border: 1px solid #4772FF;
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #4772FF;
	}
	
	.appointment-technician-item-tag-status-off{
		border-radius: 2px;
		border: 1px solid #A6AEC2;
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #A6AEC2;
	}
	
	.appointment-technician-item-tag-year{
		background: rgba(242, 130, 40, 0.1);
		border-radius: 2px;
		border: 1px solid rgba(177, 117, 34, 0.5);
		padding: 2px 6px;
		font-size: 12px;
		font-weight: 400;
		color: #B17522;
	}
	
	.appointment-technician-item-content{
		border-bottom: 1px solid #EBEDF5;
		padding: 16px 0px;
	}
</style>
